export default __webpack_public_path__ + "src/images/packages/kumbu-kumbu-lodge/2c60dbba7e37b22d395258e6ff4491d2-5.jpg";